import { useState, useEffect } from "react";
import { useSearchParams, Link } from "react-router-dom";
import UnsubscribeService from "../../../services/UnsubscribeService";
import Loader from "../../common/loader";
import { logo } from "../../imagepath";
import 'bootstrap/dist/css/bootstrap.min.css';

const Unsubscribe = () => {
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    // Get email from URL parameter if present
    const emailParam = searchParams.get('email');
    if (emailParam) {
      setEmail(emailParam);
    }
  }, [searchParams]);

  const handleUnsubscribe = async () => {
    if (!email) {
      setError("Please enter your email address.");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const response = await UnsubscribeService.unsubscribe(email);

      if (response.success) {
        setSuccess(true);
      } else {
        setError(response.error || 'Unknown error occurred');
      }
    } catch (err) {
      console.error('Unsubscribe error:', err);
      setError("An error occurred. Please try again or contact support.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="main-wrapper">
      <Loader loading={loading} />
      {/* Logo Header */}
      <div className="container mt-4 mb-3">
        <div className="row">
          <div className="col-12 text-center">
            <Link to="/">
              <img src={logo} alt="AngelWatch Logo" style={{ height: '50px', width: 'auto' }} />
            </Link>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-6">
            <div className="card shadow-sm" style={{ marginTop: '20px', border: '1px solid #ddd', borderRadius: '8px' }}>
              <div className="card-body p-4">
                <div className="text-center mb-4">
                  <h1 className="h3 mb-3" style={{ color: '#333', fontFamily: 'Arial, sans-serif' }}>
                    Unsubscribe from AngelWatch
                  </h1>
                  <p className="text-muted">
                    We&apos;re sorry to see you go. Are you sure you want to unsubscribe from our newsletter?
                  </p>
                </div>

                {!success ? (
                  <>
                    <div className="mb-3">
                      <label htmlFor="email" className="form-label">Email Address:</label>
                      <input
                        type="email"
                        id="email"
                        className="form-control"
                        placeholder="your@email.com"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        style={{ padding: '8px' }}
                      />
                    </div>

                    <div className="d-grid">
                      <button
                        className="btn"
                        onClick={handleUnsubscribe}
                        disabled={loading}
                        style={{
                          background: '#d9534f',
                          color: 'white',
                          padding: '12px 24px',
                          border: 'none',
                          borderRadius: '4px',
                          cursor: loading ? 'not-allowed' : 'pointer'
                        }}
                      >
                        {loading ? 'Processing...' : 'Unsubscribe'}
                      </button>
                    </div>

                    {error && (
                      <div className="mt-3">
                        <p className="text-danger mb-0">{error}</p>
                      </div>
                    )}
                  </>
                ) : (
                  <div className="text-center">
                    <div className="mb-3">
                      <i className="fas fa-check-circle text-success" style={{ fontSize: '3rem' }}></i>
                    </div>
                    <h4 className="text-success mb-3">Successfully Unsubscribed!</h4>
                    <p className="text-muted">
                      You have been successfully unsubscribed. Thank you for being part of our community!
                    </p>
                    <div className="mt-4">
                      <a href="/" className="btn btn-outline-primary">
                        Return to Home
                      </a>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Unsubscribe;
